interface Environment {
    REACT_APP_API_URL: string;
    REACT_APP_LEGACY_API_URL: string;
    REACT_APP_WEBAPP_URL: string;
    REACT_APP_IS_DEBUG: boolean;
}

export default {
    ...(process.env as any),
    REACT_APP_IS_DEBUG: process.env.REACT_APP_IS_DEBUG === 'true',
} as Environment;